var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmojioneFlagForItaly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.0625 20C1.0625 28.1875 6.3125 35.125 13.5625 37.6875V2.3125C6.3125 4.875 1.0625 11.8125 1.0625 20Z",
    fill: "#008C45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5625 20C38.5625 11.8125 33.3125 4.875 26.0625 2.3125V37.6875C33.375 35.125 38.5625 28.1875 38.5625 20Z",
    fill: "#CD212A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5625 37.6875C15.5 38.375 17.625 38.75 19.8125 38.75C22 38.75 24.125 38.375 26.0625 37.6875V2.3125C24.125 1.625 22 1.25 19.8125 1.25C17.625 1.25 15.5 1.625 13.5625 2.3125V37.6875Z",
    fill: "#F4F9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojioneFlagForItaly);
export default __webpack_public_path__ + "static/media/emojione_flag-for-italy.8b7cda7b8c11ff6385c0d0bb07509c98.svg";
export { ForwardRef as ReactComponent };